import { Component, OnInit } from '@angular/core';
import { AccionesService } from '../acciones/acciones.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ModuloService } from './modulo.service';
import { Aplicacion } from '../_models/aplicacion';
import { AplicacionesService } from '../aplicaciones/aplicaciones.service';

@Component({
  selector: 'app-modulo',
  templateUrl: './modulo.component.html',
  styleUrls: ['./modulo.component.scss']
})
export class ModuloComponent implements OnInit {

  moduloForm : FormGroup;

  constructor(
    private fb: FormBuilder,
    private mod_ser : ModuloService, 
    private app_serv : AplicacionesService
  ) { }

  ngOnInit(): void {

    this.moduloForm = this.fb.group({
      txt_descripcion: [null, Validators.required]
    });
    this.mod_ser.aplicacion = this.app_serv.get_aplicacion();

    this.llenar_forma();
  }

  onSubmit() {

    let data = {"txt_descripcion" : this.moduloForm.value.txt_descripcion}
    if(!this.mod_ser.id_modulo){
      this.mod_ser.crear_modulo(data);
    }else{
      this.mod_ser.actualizar_modulo(data);
    }
  }

  llenar_forma(){
    if(this.mod_ser.id_modulo){
      for (let i = 0; i < this.mod_ser.modulos.length; i++ ){

        let item =  this.mod_ser.modulos[i];

        if (item.id_modulo_app == this.mod_ser.id_modulo){
          this.mod_ser.index_update = i;
          this.moduloForm.get('txt_descripcion').setValue(item.txt_descripcion);
        }

      }
    }
  }

}
